import React from 'react'
import subMonths from 'date-fns/subMonths'
import { SearchResults } from './SearchResults'
import { CollectionDataLoaded } from '@news-mono/web-common'
import {
    getSearchPublications,
    TopicListingOptions,
} from '@news-mono/web-common'
import { DataLoaderGlobalParams } from '@news-mono/web-common'
import { DataDefinition } from 'json-react-layouts-data-loader'
import {
    ComponentServices,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import { mapListPublication } from '@news-mono/web-common'

export interface SearchRouteProps {
    searchTerm: string
}

export interface SearchDataLoaderConfig {
    searchTerm: string
    options: TopicListingOptions
}

const loadSearchData = async (
    props: SearchDataLoaderConfig,
    services: DataLoaderGlobalParams,
): Promise<CollectionDataLoaded> => {
    if (!props.searchTerm) {
        return {
            loadMorePossible: false,
            kind: 'listing',
            publications: [],
        }
    }

    const searchedPublications = await getSearchPublications(
        services,
        props.searchTerm,
        {
            ...props.options,
            // only searches the past month for db performance reasons
            publishedSince: subMonths(new Date(), 1).toISOString(),
            paging: { pageSize: 20 },
        },
    )
    const mappedListing = searchedPublications.documents.map(
        (listPublication) => mapListPublication(listPublication),
    )
    return {
        loadMorePossible: searchedPublications.morePublicationsAvailable,
        kind: 'listing',
        publications: mappedListing,
    }
}

const searchDataDefinitionLoader: DataDefinition<
    SearchDataLoaderConfig,
    CollectionDataLoaded,
    ComponentServices
> = {
    // Requires custom cache key so search terms will update when searching on the search page. Search.
    useRuntimeParams: (props) => ({
        searchTerm: JSON.stringify(props.searchTerm),
    }),
    loadData: (props, services) => loadSearchData(props, services),
}

export const SearchRegistration = createRegisterableComponentWithData(
    'search',
    searchDataDefinitionLoader,
    (props: SearchRouteProps, data, services) => {
        if (data.loaded) {
            return (
                <SearchResults
                    onEvent={services.onEvent}
                    results={data.result}
                    searchTerm={props.searchTerm}
                />
            )
        }
        return null
    },
)
